<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'
    import { modalStore } from '../stores'
    import ChargesService from '../$services/charges.service'

    import Input from '../$components/input.text.svelte'
    import File from '../$components/file.svelte'
    import Form from '../$components/form.svelte'
    import Button from '../$components/button.svelte'
    import SelectPartnersProviders from '../$components/select.partners.providers.svelte'
    import ChargesCards from './component.charges.cards.svelte'
    import ChargesRows from './component.charges.rows.svelte'

    const dispatch = createEventDispatcher()

    let data = { partner: 'FedEx' }
    let chargesFile = null
    let loading = false
    let applying = false
    let accepted = false
    let preview = null

    $: askInvoice = data.partner === 'skydropx' || data.partner === 't1envios' || data.partner === 'drenvio'

    function resetPreview() {
        preview = null
        accepted = false
    }

    async function review() {

        if(!['FedEx', 'skydropx', 't1envios', 'drenvio'].includes(data.partner))
            return toast({ message: 'La revisión de sobrepesos está disponible para FedEx, Skydropx, T1envios y Drenvio', type: 'is-warning' })

        if(!data.chargesFile)
            return toast({ message: 'Selecciona el archivo', type: 'is-warning' })

        if(askInvoice && !String(data.invoice || '').trim())
            return toast({ message: 'Ingresa el número de factura o identificador', type: 'is-warning' })

        chargesFile = data.chargesFile
        loading = true
        const resp = await ChargesService.uploadCharges({ ...data, chargesFile })
        loading = false

        if(!resp?.success)
            return toast({ message: resp?.error?.message || 'Error al revisar el archivo', type: 'is-danger' })

        preview = resp.data
        accepted = false
    }

    async function applyCharges() {

        if(askInvoice && !String(data.invoice || '').trim())
            return toast({ message: 'Ingresa el número de factura o identificador', type: 'is-warning' })

        if(!chargesFile)
            return toast({ message: 'Selecciona el archivo', type: 'is-warning' })

        applying = true
        const resp = await ChargesService.uploadCharges({ ...data, chargesFile, applyCharges: true })
        applying = false

        if(!resp?.success)
            return toast({ message: resp?.error?.message || 'Error al crear los cargos', type: 'is-danger' })

        preview = resp.data
        accepted = false
        toast({ message: `${ resp.data.created } cargos creados`, type: 'is-success' })
        dispatch('created')
        modalStore.close()
    }

</script>

<Form on:submit={ review } >
    <div class="columns">
        <div class="column">
            <SelectPartnersProviders
                options={[
                    { value: 'FedEx', text: 'FedEx cuenta' },
                    { value: 'skydropx', text: 'Skydropx' },
                    { value: 't1envios', text: 'T1envios' },
                    { value: 'drenvio', text: 'Drenvio' },
                ]}
                askProvider={false}
                bind:partner={data.partner}
                bind:provider={data.provider}
                on:select={ resetPreview }
            />
        </div>
    </div>
    {#if askInvoice}
        <div class="columns">
            <div class="column">
                <Input label="Número de factura o identificador" bind:value={data.invoice} required />
            </div>
        </div>
    {/if}
    <div class="columns">
        <div class="column" on:change={ resetPreview }>
            <File bind:file={data.chargesFile} />
        </div>
    </div>
    <div class="items-end">
        <Button type="submit" text="Revisar" icon="search" color="primary" { loading } />
    </div>
</Form>

{#if preview}
    <div class="review">
        <ChargesCards
            found={ preview.summary.found }
            missing={ preview.summary.missing }
            withCost={ preview.summary.withCost }
            review={ preview.summary.review }
            amount={ preview.summary.excess }
        />

        <ChargesRows rows={ preview.rows } partner={ data.partner } />

        <label class="accept">
            <input type="checkbox" bind:checked={ accepted } disabled={ !preview.summary.withCost } />
            Acepto crear los cargos de sobrepeso
        </label>

        <div class="items-end">
            <button
                type="button"
                class="button is-primary"
                class:is-loading={ applying }
                disabled={ !accepted || !preview.summary.withCost || applying }
                on:click={ applyCharges }
            >
                <span class="icon"><i class="fas fa-save"></i></span>
                <span>Enviar</span>
            </button>
        </div>
    </div>
{/if}

<style>
    .review {
        margin-top: 1.25rem;
    }

    .accept {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 0.75rem;
        font-size: 0.9rem;
    }
</style>
